import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onCloseShepherd", "onInsert", "onTyping"];
import styled from 'styled-components';
import { useEffect } from 'react';
import { GYPSUM, OLAF } from 'HubStyleTokens/colors';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
import { setTracker } from '../../../usage-tracking/clients/usageTracker';
import { EditorLoadingState } from '../../../editor-utilities/protected/components';
import { flexColumnStyles } from '../../../editor-utilities/protected/constants';
import { prosemirrorPaddingStyles } from '../constants/prosemirrorPaddingStyles';
import { prosemirrorInputClassName, prosemirrorMenuClassName } from './ProsemirrorRichTextEditor';
import AsyncProsemirrorRTE from './AsyncProsemirrorRTE';
import { jsx as _jsx } from "react/jsx-runtime";
const ProsemirrorStyleWrapper = styled.div.withConfig({
  displayName: "RichTextEditor__ProsemirrorStyleWrapper",
  componentId: "sc-1rymhet-0"
})(["background-color:", ";.", "{border:0 !important;padding:0 !important;min-height:155px;flex-grow:1;", ";flex-shrink:0;}.", " > div{flex-basis:1px;}.", "{display:flex;align-items:center;background-color:", ";", " flex-shrink:0;transition:opacity 0.2s ease-in-out;}.ProseMirror{flex-shrink:1;flex-basis:0;", " font-size:16px;}.ProseMirrorPlaceholder{", "}flex-grow:1;position:relative;display:flex;flex-direction:column;align-items:stretch;flex-basis:1px;"], OLAF, prosemirrorInputClassName, flexColumnStyles, prosemirrorInputClassName, prosemirrorMenuClassName, GYPSUM, prosemirrorPaddingStyles, prosemirrorPaddingStyles, prosemirrorPaddingStyles);
const RichTextEditor = props => {
  const {
    asyncCapabilitiesConfig,
    isConfigLoading,
    minHeight,
    prosemirrorConfig,
    tracker,
    trackingContext
  } = props;
  const prosemirrorStyleProps = _objectWithoutPropertiesLoose(props, _excluded);
  const skeletonMinHeight = minHeight + 16;
  useEffect(() => {
    setTracker(tracker, trackingContext);
  }, [tracker, trackingContext]);
  if (isLoading(asyncCapabilitiesConfig) || isConfigLoading) {
    return /*#__PURE__*/_jsx(EditorLoadingState, {
      minHeight: skeletonMinHeight
    });
  }
  return /*#__PURE__*/_jsx(ProsemirrorStyleWrapper, Object.assign({}, prosemirrorStyleProps, {
    children: /*#__PURE__*/_jsx(AsyncProsemirrorRTE, Object.assign({}, props, {
      prosemirrorConfig: prosemirrorConfig,
      capabilitiesConfig: getData(asyncCapabilitiesConfig) || {}
    }))
  }));
};
RichTextEditor.displayName = 'RichTextEditor';
export default RichTextEditor;